import { defineStore } from "pinia";

export const currentVersion = {
  version: process.env.VUE_APP_VERSION || "",
  commit: process.env.VUE_APP_COMMIT || "",
};

export const useVersionStore = defineStore("version", {
  state: () => ({
    current: currentVersion,
    available: null,
    updateAvailable: false,
  }),
  actions: {
    markUpdateAvailable(versionInfo) {
      this.available = versionInfo;
      this.updateAvailable = true;
    },
    reload() {
      window.location.reload();
    },
  },
});
